<section class="signature" appReveal>
  <img class="signature__bg" src="assets/image/redesign/CST1080x730.jpg" i18n-alt="@@signature.image.alt" alt="招牌泡芙特寫">
  <div class="signature__overlay"></div>
  <div class="signature__inner">
    <div class="signature__copy">
      <p class="signature__eyebrow" i18n="@@signature.eyebrow">招牌系列 Signature Series</p>
      <h2 class="signature__title font-display" i18n="@@signature.title">經典原味<br><em>酥皮泡芙</em></h2>
      <p class="signature__tagline font-display" i18n="@@signature.tagline">The Original Craquelin Choux</p>
      <p class="signature__body" i18n="@@signature.body">我們的招牌之作 — 層次分明的酥脆酥皮外殼，內餡選用馬達加斯加雲呢嗱籽搭配澳洲鮮奶手打忌廉，綿密輕柔如雲朵，品牌經典從這顆泡芙開始。</p>
      <p class="signature__body signature__body--en" i18n="@@signature.body.en">Our signature creation — a perfectly crisp craquelin shell encasing clouds of hand-whipped cream crafted with Australian fresh milk and Madagascar vanilla beans. Everything begins with this iconic choux.</p>
      <a class="signature__cta" href="#/products/40" i18n="@@signature.cta">探索經典 Discover</a>
    </div>
  </div>
</section>
